<template>
    <div v-if="isLoading" class="mt-8 flex cursor-default items-center justify-center px-8 py-6">
        <IconLoadingCats />
    </div>
    <div v-else class="cursor-default px-8 py-6">
        <!-- 摘要 -->
        <Paragraph :title="$t('abst')" :content="patentSummary?.ABST" />

        <PatentGPTSummary :patent-id="patentId" :is-free-user="isFreeUser" :gpt-summary="gptSummary" :loading="gptLoading"/>

        <!-- 技术手段 -->
        <Paragraph :title="$t('similarMeans')" :content="patentSummary?.MEANS" :noDataText="$t('noMeans')" />
        <!-- 技术效果 -->
        <Paragraph :title="$t('similarEfficacy')" :content="patentSummary?.EFFICACY" :noDataText="$t('noEfficacy')" />
        <!-- 申请人/公开日 -->
        <Paragraph :title="$t('applicationInfo')">
            <div class="flex items-center gap-8 text-xs leading-4 text-black">
                <div class="flex items-center gap-2">
                    <SolutionOrgIcon :org-info="patentSummary?.ORG_INFO" class="shrink-0" />
                    <span>{{ patentSummary?.ORG_INFO?.display_name }}</span>
                </div>

                <span v-show="patentSummary?.PBD" class=" flex shrink-0 items-center gap-2">
                    <IconTime />
                    {{ patentSummary?.PBD }}
                </span>

                <span class=" th-badge th-badge-secondary shrink-0">
                    {{ detailBasicInfo?.pn }}
                </span>
            </div>
        </Paragraph>
        <Paragraph :title="$t('applicationDomain')" v-if="patentSummary?.ADC.length">
            <div class="flex flex-wrap items-center">
                <a v-for="domain in patentSummary?.ADC" :key="domain.code" target="_blank"
                   :href="domain.href"
                   class="th-badge mb-1 mr-1 whitespace-nowrap">{{ domain.description }}</a>
            </div>
        </Paragraph>

    </div>
</template>

<script setup lang="ts">
import IconLoadingCats from '@/components/icons/IconLoadingCats.vue';
import Paragraph from '@/components/detail/Paragraph.vue';
import { useSummary } from './use-summary';
import SolutionOrgIcon from '@/components/result/SolutionOrgIcon.vue'
import IconTime from '@/components/icons/IconTime.vue'
import type { IBaseSolution, IdeaContent, TRANSLATE_LANGUAGES } from '@/types';
import PatentGPTSummary from '@/components/PatentGPTSummary.vue'
const props = defineProps<{
    translateMode: TRANSLATE_LANGUAGES,
    inputLang: TRANSLATE_LANGUAGES,
    editContent: IdeaContent,
    detailBasicInfo: IBaseSolution
}>()

const { patentSummary, gptSummary, isLoading, gptLoading, isFreeUser, patentId } = useSummary(props);
</script>
